import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "vite/modulepreload-polyfill";

import CreateYourOwn from "./components/CreateYourOwn";

const cyoRoot = document.querySelector("#cyo-root");

if (cyoRoot) {
  // Read data from attributes using dataset
  const { dataset } = cyoRoot as HTMLElement;
  const {
    courseNames: courseNamesAttr,
    hotels: hotelsAttr,
    venueName = "",
    isEu: isEuAttr,
  } = dataset;

  const courseNames: string[] = courseNamesAttr
    ? JSON.parse(courseNamesAttr)
    : [];

  const hotels: Record<string, { name: string }> = hotelsAttr
    ? JSON.parse(hotelsAttr)
    : {};

  const isEu = isEuAttr === "true";

  ReactDOM.createRoot(cyoRoot).render(
    <React.StrictMode>
      <React.Suspense>
        <BrowserRouter>
          <CreateYourOwn
            courseNames={courseNames}
            hotels={hotels}
            venueName={venueName}
            isEu={isEu}
          />
        </BrowserRouter>
      </React.Suspense>
    </React.StrictMode>,
  );
}
